exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".counter{float:none;text-align:right}.over-limit{color:red}", ""]);

// exports
